import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Tweet20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M3.15006 3.78951L3.14971 3.7907C2.97872 4.38043 2.92259 5.01773 2.93251 5.62843C2.94322 6.28783 3.05379 7.08762 3.40857 7.87H1.99991C1.46626 7.87 1.09762 8.43791 1.31488 8.92533C1.78628 9.98296 2.50715 10.9105 3.41569 11.6284C3.93779 12.0409 4.51291 12.3771 5.12366 12.6291C4.38007 13.1661 3.55928 13.5917 2.68694 13.8905C2.1092 14.0883 2.00716 14.8897 2.5169 15.226C4.02473 16.2208 5.79154 16.7507 7.59792 16.75C8.79301 16.7568 9.97776 16.5282 11.0845 16.0771C12.192 15.6258 13.1997 14.9605 14.0499 14.1194C14.9001 13.2783 15.5762 12.2778 16.0395 11.1752C16.6044 9.83076 16.7499 8.43999 16.7499 7L18.9999 4L16.1015 4.72461C14.8503 2.9498 12.2185 2.73096 10.6897 4.25978C10.2055 4.74394 9.87565 5.35356 9.73172 6.01222C8.8065 5.96348 7.89498 5.75547 7.03772 5.39583C6.05433 4.92298 5.16519 4.27502 4.41382 3.48361C4.02288 3.07184 3.30942 3.24453 3.15006 3.78951ZM11.7503 5.32044C12.5399 4.5309 13.8599 4.5309 14.6495 5.32044C15.0339 5.70488 15.2499 6.22631 15.2499 6.77C15.2499 8.08855 15.1767 9.35634 14.6566 10.5942C14.2697 11.515 13.7051 12.3506 12.995 13.053C12.2849 13.7555 11.4433 14.3111 10.5184 14.6881C9.59342 15.0651 8.60322 15.256 7.60441 15.25L7.59941 15.25C6.58711 15.2507 5.58961 15.0523 4.66198 14.6715C5.58618 14.1906 6.43864 13.5774 7.19143 12.849C7.62035 12.434 7.39509 11.6832 6.80854 11.5729C5.90896 11.4037 5.06384 11.0189 4.34564 10.4514C3.94895 10.138 3.59752 9.77397 3.29958 9.37H4.79991C5.44344 9.37 5.78713 8.57493 5.34624 8.10616C4.62964 7.34426 4.43281 6.35927 4.43162 5.52578C5.04094 6.00704 5.70302 6.42013 6.40623 6.75656C6.41679 6.76161 6.42747 6.76642 6.43826 6.77098C7.69699 7.30226 9.05497 7.55758 10.4207 7.51972C10.8267 7.50846 11.1499 7.17612 11.1499 6.77C11.1499 6.22631 11.3659 5.70489 11.7503 5.32044Z'
      fill='currentColor'
    />
  </Svg>
);

Tweet20.displayName = 'Tweet20';
export default Tweet20;
